 import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { COMPANY_NAME } from "../config";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  // 🔥 Hide sidebar completely on Inspection Report page
  if (location.pathname === "/InspectionReport") {
    return null;
  }

  const menuItems = [
    { path: "/dashboard", label: "Dashboard"},
    { path: "/master", label: "Master" },
    // { path: "/vendorusers", label: "Vendor Users" },
    // { path: "/VendorTeam", label: "Vendor Team" },
    { path: "/InspectionReport", label: "Report" }
  ];

  return (
    <nav className="bg-gradient-to-b from-blue-400 to-blue-500 text-white min-h-screen w-64 shadow-lg">
      {/* Company Name Header */}
      <div className="px-6 py-8 border-b border-blue-500">
        <h1 className="text-xl font-bold text-center leading-tight">
          {COMPANY_NAME}
        </h1>
        <p className="text-sm text-blue-200 text-center mt-1">Quality Control System</p>
      </div>

      {/* Menu Items */}
      <div className="px-4 py-6 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
              location.pathname === item.path
                ? "bg-blue-700 shadow-md"
                : "hover:bg-blue-700 hover:shadow-md"
            }`}
          >
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-3 mt-8 rounded-lg bg-red-600 hover:bg-red-700 transition-all duration-200 shadow-md"
        >
          <span className="mr-3 text-lg">🚪</span>
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </nav>
  );
}
